/**
 * Friendly labels for known permission scopes. The selectable set in the create
 * modal is sourced from the caller's own permissions, not this map, so a new
 * backend scope still appears - just title-cased from its raw value until a
 * label is added here. Shared between the create modal and the table chips so
 * both render the same friendly text.
 */
export const PERMISSION_LABELS: Record<string, string> = {
  market_data: 'Market data',
  risk: 'Risk',
  pricer: 'Pricer',
  pnl: 'PnL',
  backtester: 'Backtester',
  portfolio_performance: 'Portfolio performance',
  api_key_read: 'API key read',
  api_key_write: 'API key write',
  admin: 'Admin',
};

export const labelForPermission = (value: string): string =>
  PERMISSION_LABELS[value] ?? value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
